import * as React from 'react';
import PropTypes from 'prop-types';
import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';

function ValueLabelComponent(props) {
  const { children, value } = props;

  return (
    <Tooltip enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  value: PropTypes.number.isRequired,
};


const AirbnbSlider = styled(Slider)(({ theme }) => ({
  color: '#3a8589',
  height: 3,
  padding: '13px 0',
  '& .MuiSlider-thumb': {
    height: 27,
    width: 27,
    backgroundColor: '#fff',
    border: '1px solid currentColor',
    '&:hover': {
      boxShadow: '0 0 0 8px rgba(58, 133, 137, 0.16)',
    },
    '& .airbnb-bar': {
      height: 9,
      width: 1,
      backgroundColor: 'currentColor',
      marginLeft: 1,
      marginRight: 1,
    },
  },
  '& .MuiSlider-track': {
    height: 3,
  },
  '& .MuiSlider-rail': {
    color: theme.palette.mode === 'dark' ? '#bfbfbf' : '#d8d8d8',
    opacity: theme.palette.mode === 'dark' ? undefined : 1,
    height: 3,
  },
}));

function AirbnbThumbComponent(props) {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
    </SliderThumb>
  );
}

AirbnbThumbComponent.propTypes = {
  children: PropTypes.node,
};


export default function MiSlider(props) {
    const [value, setValue] = React.useState(props.valores);
    const [titulo, setTitulo] = React.useState((props.tipo==1?props.titulo + ": " + parseFloat(props.valores[0]).toLocaleString('en-US', {minimumFractionDigits: 2}) + " - " + parseFloat(props.valores[1]).toLocaleString('en-US', {minimumFractionDigits: 2}): props.titulo + ": " + props.valores[0] + " - " + props.valores[1]))

    React.useEffect(()=>{
        setTitulo((props.tipo==1?props.titulo + ": " + parseFloat(value[0]).toLocaleString('en-US', {minimumFractionDigits: 2}) + " - " + parseFloat(value[1]).toLocaleString('en-US', {minimumFractionDigits: 2}): props.titulo + ": " + value[0] + " - " + value[1]));
    }, [value])

    const handleChange = (event, newValue) => {
      setValue(newValue);
      props.update(newValue)
    };

  return (
    <Box>
        <Typography gutterBottom>{titulo}</Typography>
      <AirbnbSlider
        slots={{ thumb: AirbnbThumbComponent }}
        valueLabelDisplay='auto'
        value={value}
        onChange={handleChange}
        min={props.min}
        max={props.max}
        getAriaLabel={(index) => (index === 0 ? 'Minimo' : 'Maximo')}
        defaultValue={[props.min, props.max]}
      />
    </Box>
  );
}